<template>
	<div id="filterdiv">
		<div class="filtertitle">
			<slot name="left"></slot>
			<span class="span" @click="btnshow($event)"><img src="../../assets/img/shaixuan.png"/>{{sname}}</span>
			<slot name="right"></slot>
		</div>
		<div class="filter" v-if="show">
			<span class="trianglebg" :style="'left:' +filterleft1+'px'"></span>
			<span class="triangle" :style="'left:' +filterleft2+'px'"></span>
			<div class="inputs" >
				<slot name="form"></slot>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				filterleft1: "",
				filterleft2: "",
				show: false,
				selectshow: null,
			}
		},
		props: {
			filname: "",
			list: "",
		},
		computed: {
			sname: function() {
				if(!this.show) {
					return this.filname;
				} else if(this.show) {
					return "收起";
				}
			}
		},
		methods: {
			btnshow(e) {
				var span = document.getElementsByClassName('span')[0];
				this.filterleft1 = span.offsetLeft + (span.offsetWidth / 2) - 7;
				this.filterleft2 = this.filterleft1 + 1;
				if(!this.show) {
					this.show = true;
				} else if(this.show) {
					this.show = false;
				}
			},
		}
	}
</script>

<style scoped lang="less">
	#filterdiv {
		width: 100%;
		position: relative;
		display: flex;
		flex-direction: column;
	}
	
	.filtertitle {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.span {
		color: #6669e3;
		font-size: 14px;
		cursor: pointer;
		display: flex;
		align-items: center;
		img {
			width: 18px;
			height: 18px;
			margin-right: 5px;
		}
	}
	
	.filter {
		width: 100%;
		border: 1px solid #d9dbe2;
		position: relative;
		border-radius: 6px;
		margin-bottom: 16px;
		box-sizing: border-box;
		.triangle {
			position: absolute;
			display: block;
			top: -9px;
			left: 1px;
			width: 0;
			height: 0;
			border-width: 0 5.5px 10px;
			border-style: solid;
			border-color: transparent transparent #fff;
			z-index: 100;
		}
		.trianglebg {
			position: absolute;
			display: block;
			top: -10px;
			left: 0;
			width: 0;
			height: 0;
			border-width: 0 6.5px 10px;
			border-style: solid;
			border-color: transparent transparent #d9dbe2;
		}
		.inputs {
			line-height: 0;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			align-content: space-between;
			margin: 8px 0;
			.form{
				display: flex;
				flex-wrap:wrap;
				align-items: center;
				.row{
					margin-right: 5px;
				}
			}
		}
	}
</style>